module.exports = __webpack_public_path__ + "img/community.79059fda.png";